// Import dependencies
import { builderFetch } from '@builder/core/utilities';
const { isEmpty } = _uo.utility;

/**
 * Adds a new loop to the current recipe
 *
 * @param {Number} loopID The loop ID (post ID)
 * @param {String} integrationCode The unique code of the integration (e.g. WP)
 * @param {String} loopFilterCode The unique code of the loop filter (e.g. WP_USER_EMAIL_ENDS_WITH)
 * @param {String} fields JSON string with the values of the fields
 * @param {String} backup JSON string with data that'll be used if the loop filter is missing in the directory
 * @return {Promise} The apiFetch promise
 */
const createLoopFilter = ( loopID, integrationCode, loopFilterCode, fields, backup ) => {
	if ( isEmpty( integrationCode ) ) {
		throw new Error( `createLoopFilter: integrationCode must be defined` );
	}

	if ( isEmpty( loopFilterCode ) ) {
		throw new Error( `createLoopFilter: loopFilterCode must be defined` );
	}

	// Get the loop
	const loop = UncannyAutomator._core.recipe.item.loop.getLoop( loopID );

	// If the item is not define, stop here
	if ( isEmpty( loop ) ) {
		throw new Error( `createLoopFilter: The loop ${ loopID } doesn't exist` );
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: `loop/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		data: {
			action: 'add_filter',
			// eslint-disable-next-line camelcase
			loop_id: loopID,
			// eslint-disable-next-line camelcase
			loop_filter_integration_code: integrationCode,
			// eslint-disable-next-line camelcase
			loop_filter_code: loopFilterCode,
			fields: fields,
			backup: backup
		},
		snackbar: {
			loading: _uo.utility.escHTML( wp.i18n.__( 'Adding new filter loop', 'uncanny-automator' ) ),
			success: _uo.utility.escHTML( wp.i18n.__( 'Filter loop added successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/loop/create-loop-filter', {
				detail: {
					loopID: loopID,
					loopFilterIntegrationCode: integrationCode,
					loopFilterCode: loopFilterCode,
					fields: fields,
					backup: backup
				}
			} ) );
		}

		return response;
	} );
}

export default createLoopFilter;
